

import { motion } from "framer-motion";
import { Container } from "@/components/ui/Container";
import { SectionHeading } from "@/components/ui/SectionHeading";
import { fadeInUp } from "@/lib/motion";
import {
  Search,
  Database,
  Cube,
  PlaySolid,
  DesignPencil,
  Settings,
} from "iconoir-react";
import { useLanguage } from "@/components/LanguageContext";

export function MethodologySection() {
  const { t } = useLanguage();

  const steps = [
    { 
      title: t("Diagnostic & Collecte", "Diagnostic & Data Collection"), 
      desc: t("Comptages multimodaux, enquêtes terrain, photogrammétrie, IA vidéo-analytics.", "Multi-modal counts, field surveys, photogrammetry, AI video-analytics.") 
    },
    { 
      title: t("Modélisation & Analyse", "Modeling & Analysis"), 
      desc: t("Microsimulation, modélisation macroscopique, SIG, analyse spatiale.", "Microsimulation, macroscopic modeling, GIS, spatial analysis.") 
    },
    { 
      title: t("Planification & Ingénierie", "Planning & Engineering"), 
      desc: t("PMUD, plans de circulation, dimensionnement d'infrastructures, stationnement.", "SUMP, circulation plans, infrastructure sizing, parking policies.") 
    },
    { 
      title: t("Pilotage Digital", "Digital Steering"), 
      desc: t("Tableaux de bord PowerBI, solutions AVISIUM Analytics, observatoires.", "PowerBI dashboards, AVISIUM Analytics solutions, transport observatories.") 
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-mineral overflow-hidden">
      <Container>
        <SectionHeading
          overline={t("Méthodologie", "Methodology")}
          title={t("Une maîtrise intégrale de la chaîne de décision", "Full mastery of the decision chain")}
          subtitle={t("De la collecte terrain au pilotage digital, notre approche intègre ingénierie et data science.", "From field collection to digital steering, our approach integrates engineering and data science.")}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {steps.map((step, i) => (
            <motion.div
              key={step.title}
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: i * 0.1 }}
              className="relative p-6 bg-warm-white rounded-2xl border border-mineral-dark hover:border-amber/40 transition-all duration-300 group shadow-sm hover:shadow-md"
            >
              <div className="text-sm font-bold text-amber tracking-widest mb-3">
                {t("ÉTAPE", "STEP")} {i + 1}
              </div>
              <h3 className="text-lg font-semibold text-charcoal mb-3 font-display">
                {step.title}
              </h3>
              <p className="text-sm text-graphite leading-relaxed">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
}
